import React, { Component } from "react";
import PropTypes from "prop-types";
import Spinner from "react-spinner";
import { connect } from "react-redux";
import moment from "moment";

import BottomControls from "./BottomControls";
import DayEntries from "./DayEntries";
import DayEntry from "./DayEntry";
import {
  fetchEntriesAndAdvancePage,
  toggleSubmitGroupEntry,
} from "../../actions/historyActions";
import {
  submitEntry,
  deleteEntry,
  setEntry
} from "../../actions/entryActions";
import { getInitialDate, getTotalHours } from "../../actions/userActions";
import { DayGroupsShape, EntryStateShape, EntriesShape, HistoryContext } from "../../props";
import { filterDayGroups } from "../../utils/day-groups";
import confirmWith from "../../utils/confirm-with";

require("./HistoryList.scss");

class HistoryList extends Component {
  componentDidMount() {
    // Trigger a fetch on first mount
    this.props.fetchEntries();
  }

  componentDidUpdate(prevProps) {
    const moreToFetch = !this.props.loading && this.props.hasMore;
    const versionChanged = prevProps.version !== this.props.version;

    if (moreToFetch || versionChanged) {
      // Fetch until we have everything on update
      this.props.fetchEntries();
    }
  }

  render() {
    return (
      <div className="history-list">
        <div className="entries-wrapper">
          <DayEntries
            dayGroups={this.props.dayGroups}
            fetchEntries={this.props.fetchEntries}
            hasMore={this.props.hasMore}
            loading={this.props.loading}
            onClone={this.props.onClone}
            onCreate={this.props.onCreate}
            onDelete={this.props.onDelete}
            onEdit={this.props.onEdit}
            onSubmit={this.props.onSubmit}
            selected={this.props.submitGroup}
            setSubmitGroupEnabled={this.props.setSubmitGroupEnabled}
          />
        </div>
        <HistorySpinner loading={this.props.loading} />
        <BottomControls />
      </div>
    );
  }
}

HistoryList.displayName = "History.List";

HistoryList.propTypes = {
  dayGroups: DayGroupsShape,
  editingEntry: EntryStateShape,
  entries: EntriesShape,
  fetchEntries: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  historyContext: HistoryContext,
  loading: PropTypes.bool.isRequired,
  onClone: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  version: PropTypes.string.isRequired,
};

HistoryList.defaultProps = {
  entries: [],
  hasMore: false,
  loading: true,
  version: "0",
};

export function HistorySpinner({ loading }) {
  if (!loading) {
    return null;
  }

  return (
    <div className="historySpinnerContainer">
      <Spinner className="historySpinner"/>
    </div>
  );
}

HistorySpinner.displayName = "History.List.Spinner";

HistorySpinner.propTypes = {
  loading: PropTypes.bool.isRequired,
};

HistorySpinner.defaultProps = {
  loading: false,
};

function mapStateToProps(state) {
  const historyContext =  state.historyFilters.context;
  const loading = state.entry.deleteProcessing || state.entry.submitProcessing || state.entries.entriesInTransit;
  const { dayGroups: rawDayGroups, entries, hasMore, submitGroup, version } = state.entries;

  const editingEntry = state.entry;

  const dayGroups = filterDayGroups(rawDayGroups, historyContext);

  return {
    dayGroups,
    editingEntry,
    entries,
    hasMore,
    historyContext,
    loading,
    submitGroup,
    version,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchEntries() {
      return dispatch(fetchEntriesAndAdvancePage());
    },
    onCreate(entry, workDay) {
      const newEntry = {...entry};

      if (workDay.enabled) {
        newEntry.hours = workDay.workingHours;
      }

      return dispatch(setEntry(newEntry));
    },
    onClone(entry) {
      let clonedEntry = {
        ...entry,
        _clonedFrom: entry.id,
        entryDate: moment()
      };
      delete clonedEntry.id;

      dispatch(setEntry(clonedEntry));
    },
    async onDelete(entry, editingEntry) {
      return await confirmWith("Are you sure you want to delete this entry?", async () => {
        await dispatch(deleteEntry(entry));

        if (editingEntry && (entry.id === editingEntry._clonedFrom)) {
          await dispatch(setEntry(null));
        }
      });
    },
    onEdit(entry) {
      return dispatch(setEntry(entry));
    },
    async onSubmit(entry) {
      return await confirmWith("Are you sure you want to submit this entry?", async function() {
        await dispatch(submitEntry(entry));
      });
    },
    setSubmitGroupEnabled(entry, enabled) {
      return dispatch(toggleSubmitGroupEntry(entry, enabled));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HistoryList);



// WEBPACK FOOTER //
// ./app/components/History/HistoryList.jsx